var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c("div", { staticClass: "template7wrapper" }, [
    _c("h2", [_vm._v(_vm._s(_vm.question.title))]),
    _vm._v(" "),
    _c("h3", [_vm._v(_vm._s(_vm.question.subTitle))]),
    _vm._v(" "),
    _c("div", { staticClass: "answersWrapper" }, [
      _c(
        "div",
        { staticClass: "answersItemsWrapper" },
        _vm._l(this.answers, function (answer) {
          return _c(
            "div",
            {
              key: answer.id,
              staticClass: "answerItem",
              class: [
                answer.selected ? "selected" : "",
                answer.disabled ? "disabled" : "",
              ],
              attrs: { title: answer.text },
              on: {
                touchend: function ($event) {
                  $event.preventDefault()
                  return ((event) => {
                    _vm.selectAnswer(answer.id)
                    _vm.mouseOver(answer.id)
                  }).apply(null, arguments)
                },
                click: function ($event) {
                  return _vm.selectAnswer(answer.id)
                },
                mouseenter: function ($event) {
                  return _vm.mouseOver(answer.id)
                },
                mouseleave: function ($event) {
                  return _vm.mouseOut(answer.id, $event)
                },
              },
            },
            [
              _vm._v(
                "\n                " + _vm._s(answer.title) + "\n            "
              ),
            ]
          )
        }),
        0
      ),
      _vm._v(" "),
      _c(
        "div",
        { staticClass: "answersDetailsWrapper" },
        [
          _c(
            "transition-group",
            { attrs: { name: "fade", tag: "div" } },
            _vm._l(this.answers, function (answer) {
              return _c(
                "div",
                {
                  directives: [
                    {
                      name: "show",
                      rawName: "v-show",
                      value: answer.hovered,
                      expression: "answer.hovered",
                    },
                  ],
                  key: answer.id,
                  staticClass: "answerDetail",
                },
                [
                  _c("p", { staticClass: "subtitle" }, [
                    _vm._v(
                      "\n                        " +
                        _vm._s(answer.subTitle) +
                        "\n                    "
                    ),
                  ]),
                ]
              )
            }),
            0
          ),
        ],
        1
      ),
    ]),
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }